import { twMerge } from 'tailwind-merge'

interface SideImageFormProps {
  title: string
  className: string
}

export function SideImageForm({ title, className }: SideImageFormProps) {
  return (
    <div
      className={twMerge(
        'hidden bg-cover bg-bottom lg:col-span-5 lg:flex',
        className,
      )}
    >
      <div className="flex size-full items-center justify-center bg-monochromatic-500/50">
        <h1 className="card-title text-shadow-title w-1/2 text-4xl text-white drop-shadow-sm xl:text-5xl 2xl:w-3/5">
          {title}
        </h1>
      </div>
    </div>
  )
}
